import { getClaims } from '@/app/api';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IClaim } from '@/pages/main/types.ts';

interface IIntialState {
  allClaims: IClaim[];
  data: IClaim[];
  loading: boolean;
  isProcess: boolean;
}

const initialState: IIntialState = {
  allClaims: [],
  data: [],
  loading: false,
  isProcess: true,
};

export const fetchClaims = createAsyncThunk<IClaim[], void>(
  'claims/fetchClaims',
  async () => {
    const response = await getClaims();
    return response.data;
  }
);

const claimsSlice = createSlice({
  name: 'claims',
  initialState,
  reducers: {
    setChangeProccess: (state, action: PayloadAction<boolean>) => {
      state.isProcess = action.payload;
      state.data = state.allClaims.filter(
        (caseItem) => caseItem.isMissingInformation !== state.isProcess
      );
    },
    updateClaimStatus: (state, action: PayloadAction<number>) => {
      state.allClaims = state.allClaims.map((claim) =>
        claim.id === action.payload
          ? { ...claim, isMissingInformation: false }
          : claim
      );

      state.data = state.allClaims.filter(
        (caseItem) => caseItem.isMissingInformation !== state.isProcess
      );
    },
    updateClaimObjection: (
      state,
      action: PayloadAction<{ id: number; status: boolean }>
    ) => {
      state.data = state.data.map((claim) =>
        claim.id === action.payload.id
          ? { ...claim, objection: action.payload.status }
          : claim
      );
    },
    removeClaimById: (state, action: PayloadAction<number>) => {
      state.data = state.data.filter((claim) => claim.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClaims.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchClaims.fulfilled,
        (state, action: PayloadAction<IClaim[]>) => {
          state.loading = false;
          state.allClaims = action.payload;
          state.data = action.payload.filter(
            (caseItem) => caseItem.isMissingInformation !== state.isProcess
          );
        }
      )
      .addCase(fetchClaims.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setChangeProccess,
  updateClaimStatus,
  updateClaimObjection,
  removeClaimById,
} = claimsSlice.actions;
export default claimsSlice.reducer;
